import React from "react";
import {Link, Navigate, Route, Routes} from "react-router-dom";
import SideNavigation from "./SideNavigation";
import Login from "../pages/Login";
import Logout from "../pages/Logout";
import Register from "../pages/Register";

import Home from "../pages/Home"
import Users from "../pages/Users/Users"
import UserDetails from "../pages/Users/UserDetails"
import AccessCodes from "../pages/AccessCodes/AccessCodes"
import ModifyAccessCodes from "../pages/AccessCodes/ModifyAccessCodes"
import Accreditation from "../pages/Accreditation/Accreditation"
import Marketing from "../pages/Marketing/Marketing"
import Affiliates from "../pages/Affiliates/Affiliates"
import Error from "../pages/Error"
import Authenticator from "../pages/Authenticator";

const AppLayout = () => {

    return (
        <div className="page-container">
            <SideNavigation />
            <div className="content-container">
                <Routes>
                    <Route exact path="/" element={<Navigate to="/home"/>}/>
                    <Route path="/home" element={
                        <React.Suspense fallback={<>...</>}>
                            <Home/>
                        </React.Suspense>
                    }/>
                    <Route path="/login" element={
                        <React.Suspense fallback={<>...</>}>
                            <Login />
                        </React.Suspense>
                    }/>
                    <Route path="/authenticate" element={
                        <React.Suspense fallback={<>...</>}>
                            <Authenticator />
                        </React.Suspense>
                    }/>
                    <Route path="/logout" element={
                        <React.Suspense fallback={<>...</>}>
                            <Logout />
                        </React.Suspense>
                    }/>
                    <Route path="/register" element={
                        <React.Suspense fallback={<>...</>}>
                            <Register />
                        </React.Suspense>
                    }/>
                    <Route path="/error" element={
                        <React.Suspense fallback={<>...</>}>
                            <Error />
                        </React.Suspense>
                    }/>
                    <Route path="/users" element={
                        <React.Suspense fallback={<>...</>}>
                            <Users/>
                        </React.Suspense>
                    }/>
                    <Route path="/users/:user_email" element={
                        <React.Suspense fallback={<>...</>}>
                            <UserDetails />
                        </React.Suspense>
                    }/>
                    <Route path="/access-codes" element={
                        <React.Suspense fallback={<>...</>}>
                            <AccessCodes />
                        </React.Suspense>
                    }/>
                    <Route path="/access-codes/:access_code_id" element={
                        <React.Suspense fallback={<>...</>}>
                            <ModifyAccessCodes />
                        </React.Suspense>
                    }/>
                    <Route path="/accreditation" element={
                        <React.Suspense fallback={<>...</>}>
                            <Accreditation />
                        </React.Suspense>
                    }/>
                    <Route path="/marketing" element={
                        <React.Suspense fallback={<>...</>}>
                            <Marketing />
                        </React.Suspense>
                    }/>
                    <Route path="/affiliates" element={
                        <React.Suspense fallback={<>...</>}>
                            <Affiliates />
                        </React.Suspense>
                    }/>
                </Routes>
            </div>
        </div>
    )
}

export default AppLayout;